export const catalogOptions = {
  title: {
    default: 'Daeiltec',
  },
  langSet: ['en'],
  pageMap: [
    'Cover',
    'Index',
    'Machine-introduction',
    'Machine-information',
    'Tech-intro',
    'Tech-spec-1',
    'Tech-spec-2',
    'Tech-triple',
    'Tech-product-1',
    'Tech-product-2',
    'Tech-product-3',
    'AS',
    'LastCover-1',
    'LastCover-2',
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 920,
  responsiveMode: false,
  breakpoint: 768,
};
